import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const AmazonBrandRegistry = () => {
  const usps = [
    {
      title: 'Amazon Brand Protection',
      description: 'Gain powerful tools to protect your listings from counterfeiters and unauthorized sellers. Take complete control of your brand\'s presence on the world\'s largest marketplace.'
    },
    {
      title: 'Enhanced Content Access',
      description: 'Unlock A+ Content, Brand Stores, and Sponsored Brands advertising to showcase your products professionally and increase conversion rates on Amazon.'
    },
    {
      title: 'Complete Registration Support',
      description: 'We handle both trademark registration and Amazon Brand Registry enrollment, ensuring seamless integration and full brand protection on the marketplace.'
    },
    {
      title: 'Counterfeit Reporting Tools',
      description: 'Access Amazon\'s automated protections and reporting tools to quickly remove counterfeit listings and protect your brand reputation and sales.'
    }
  ];

  const whyChooseContent = {
    about: 'Amazon Brand Registry provides essential tools for brand owners selling on Amazon. With a registered trademark, you gain access to powerful protections, enhanced marketing features, and control over your brand\'s presentation on the world\'s largest marketplace.',
    intro: 'Protect your Amazon business and unlock premium features with Trademark Vector\'s comprehensive Brand Registry services.',
    paragraph1: 'Our Amazon Brand Registry service combines trademark registration with Brand Registry enrollment, giving you everything needed to protect and grow your Amazon business. We understand Amazon\'s requirements and ensure your application succeeds.',
    paragraph2: 'From preventing hijackers to creating stunning A+ Content, Brand Registry is essential for serious Amazon sellers. Let us handle the legal complexity while you focus on growing your business on Amazon.'
  };

  return (
    <ServiceTemplate
      title="Amazon Brand Registry"
      subtitle="Protect Your Brand and Unlock Premium Features on Amazon"
      description="Secure your Amazon business with Brand Registry enrollment. Gain access to powerful brand protection tools, enhanced content features, and control over your product listings."
      heroImage="https://images.unsplash.com/photo-1586880244406-556ebe35f282"
      aboutImage="https://images.unsplash.com/photo-1758518727888-ffa196002e59?w=800"
      serviceId="amazon-brand-registry"
      metaTitle="Amazon Brand Registry Enrollment & Protection | Trademark Vector"
      metaDescription="Enroll in Amazon Brand Registry with expert help. Unlock A+ Content, Brand Stores, counterfeit reporting & full control over your product listings."
      usps={usps}
      whyChooseContent={whyChooseContent}
    />
  );
};

export default AmazonBrandRegistry;
